<script setup>
import { onMounted } from 'vue'
import router from '../router'

function getSafeRedirectUrl() {
  const target = localStorage.getItem('redirectUrl')
  localStorage.removeItem('redirectUrl')
  return target && target.startsWith('/') && !target.startsWith('//') ? target : '/'
}

onMounted(() => {
  router.replace(getSafeRedirectUrl())
})
</script>

<template>
  <div />
</template>
